<template>
  <MediaImage
    :always-fill="true"
    :link="link"
    :link-title="linkTitle"
    :max-width="480"
    :media="media"
    :show-captions="true"
    :use-aspect="true"
  />
</template>

<script setup lang="ts">
import type { InlineImageLinkStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: InlineImageLinkStoryblok
}>()

const media = computed(() =>
  props.blok.image && props.blok.image.filename ? props.blok.image : {},
)
const link = computed(() => {
  if (props.blok.link?.url) return props.blok.link.url
  return (
    '/' + (props.blok.link?.cached_url || props.blok.link?.story?.full_slug)
  )
})
const linkTitle = computed(() => props.blok.title)
</script>
